import { App } from '@capacitor/app';
import { navigate } from 'gatsby';
import {
  applicationFlowPaths,
  customLayoutPaths,
} from '../routes';
import { openInCapacitorBrowser } from '../utils/platform';

const ALLOWED_HOSTS = new Set(['dentalpost.net', 'www.dentalpost.net']);

function isInAppPath(path: string): boolean {
  if (path.startsWith('/app')) return true;
  if (path.startsWith('/blog/')) return true;
  if (path.startsWith('/dental-jobs/events/')) return true;
  return (
    customLayoutPaths.some((p) => path.startsWith(p)) ||
    applicationFlowPaths.some((p) => path.startsWith(p))
  );
}

function handleDeepLink(url: string): void {
  try {
    const parsed = new URL(url);
    if (!ALLOWED_HOSTS.has(parsed.hostname)) return;

    const path = parsed.pathname;
    const suffix = parsed.search + parsed.hash;

    if (isInAppPath(path)) {
      navigate(path + suffix);
    } else {
      openInCapacitorBrowser(path + suffix);
    }
  } catch (err) {
    console.warn('[deep-links] appUrlOpen ignored:', url, err);
  }
}

export function configureDeepLinks(): void {
  App.addListener('appUrlOpen', (event) => {
    handleDeepLink(event.url);
  }).catch((err) => {
    console.error('[deep-links] failed to register listener:', err);
  });
}
